//export const BaseIp = "http://192.168.1.104:8088/"; // Local Server
// export const BaseIp = "http://192.168.29.114:8087/"; // Local Server

export const BaseIp = "https://jcjdigitallibrary.in/"; // Web Server

export const ProIp = BaseIp + "digital-library/";  // Local Server with AppName /digital-library/userLoginAPI